<script setup lang="ts">
/** Unread count for the navigation. Hidden entirely at zero. */
import { computed } from 'vue';

const props = withDefaults(defineProps<{ count: number; max?: number }>(), { max: 99 });

const label = computed(() => (props.count > props.max ? `${props.max}+` : String(props.count)));
</script>

<template>
  <span
    v-if="count > 0"
    class="inline-flex min-w-[1.125rem] items-center justify-center rounded-full bg-danger px-1 text-[0.625rem] font-semibold leading-[1.125rem] text-white"
    :aria-label="`${count} unread`"
  >
    {{ label }}
  </span>
</template>
